import { useCallback, useEffect, useState } from 'react'

// eslint-disable-next-line no-unused-vars
import { IData } from '../interfaces/table'

export const usePaginate = () => {
  const [page, setPage] = useState<number>(0)

  const [index, setIndex] = useState<number>(0)

  const [endIndex, setEndIndex] = useState<number>(0)

  const [showItems] = useState<number>(10)

  const [totalItems, setTotalItems] = useState<number>(0)

  const settingIndex = useCallback(() => {
    setIndex(page * showItems)
  }, [page])

  useEffect(() => {
    settingIndex()
  }, [settingIndex])

  const settingEndIndex = useCallback(() => {
    setEndIndex(index + showItems)
  }, [index])

  useEffect(() => {
    settingEndIndex()
  }, [settingEndIndex])

  const isFirstPage = useCallback(() => {
    return page === 0
  }, [page])

  const isLastPage = useCallback(() => {
    return totalItems <= endIndex
  }, [totalItems, endIndex])

  const nextPage = () => {
    setPage(page + 1)
  }

  const previousPage = () => {
    setPage(page - 1)
  }

  const paginate = useCallback(
    (data: IData, index: number, endIndex: number, totalItems: number) => {
      const paginateData: IData = []

      const formattedEndIndex = totalItems < endIndex ? totalItems : endIndex

      for (let i = index; i < formattedEndIndex; i++) {
        if (data[i]) paginateData.push(data[i])
      }

      return paginateData
    },
    []
  )

  return {
    page,
    setPage,
    index,
    endIndex,
    totalItems,
    setTotalItems,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    paginate
  }
}
